export default {
	mounted(el) {
	  applyNumberSanitizer(el)
	},
	updated(el) {
	  applyNumberSanitizer(el)
	},
  }
  
  function applyNumberSanitizer(el) {
	const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
	if (!input) return
  
	// Bloqueia a digitação de qualquer caractere que não seja número
	input.addEventListener('keydown', (event) => {
	  const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete']
	  if (
		!/^[0-9]$/.test(event.key) &&
		!allowedKeys.includes(event.key)
	  ) {
		event.preventDefault()
	  }
	})
  
	// Sanitiza colagem ou edições via mouse
	const sanitize = () => {
	  const sanitized = input.value.replace(/\D+/g, '') // remove tudo que não for número
	  if (input.value !== sanitized) {
		input.value = sanitized
		input.dispatchEvent(new Event('input'))
	  }
	}
  
	input.addEventListener('input', sanitize)
	input.addEventListener('blur', sanitize)
  }
  